// Updated updatePointsOnMessage.js
import { doc, getDoc, updateDoc, increment } from "firebase/firestore";
import { db } from "../firebase";
import { calculateRankProgression } from "./calculateRankProgression";
import { calculatePointMultiplier } from "./pointMultiplier";
import { updateUserStreak } from "./updateUserStreak";
import { checkAndUpdateAchievements } from "./achievements";
import { recordUserEvent, USER_EVENT_TYPES } from "./userEvents";

export const updatePointsOnMessage = async (userId, thumbsUp = false) => {
  const userStatsRef = doc(db, "userStats", userId);

  try {
    // First update streak and get any streak-related data
    const streakData = await updateUserStreak(userId);
    
    const userStatsDoc = await getDoc(userStatsRef);
    if (!userStatsDoc.exists()) return;
    
    const data = userStatsDoc.data();

    // Calculate multiplier
    const { multiplier, isNightOwl, isWeekend, isPeakHours } = calculatePointMultiplier();

    // Calculate points to add
    const basePoints = thumbsUp ? 5 : 2;
    const pointsForAction = Math.round(basePoints * multiplier);
    const newTotalPoints = (data.points.total || 0) + pointsForAction;
    const newDailyPoints = (data.points.daily || 0) + pointsForAction;

    // Create update payload
    const updatePayload = {
      "points.total": newTotalPoints,
      "points.daily": newDailyPoints,
    };

    // Add multiplier tracking
    if (isNightOwl) updatePayload["multipliers.nightowl"] = increment(1);
    if (isWeekend) updatePayload["multipliers.weekend"] = increment(1);
    if (isPeakHours) updatePayload["multipliers.peakHours"] = increment(1);

    // Increment achievement counters based on action
    if (thumbsUp) {
      updatePayload["achievements.thumbsUpReceived"] = increment(1);
    } else {
      // Increment message count
      updatePayload["achievements.messagesSent"] = increment(1);
    }

    // Update Firestore document
    await updateDoc(userStatsRef, updatePayload);

    // Recalculate rank progression
    await calculateRankProgression(userId);
    
    // Get updated user data after the update
    const updatedUserDoc = await getDoc(userStatsRef);
    const updatedData = updatedUserDoc.data();

    // Check for achievements
    let achievementResults = null;
    
    if (thumbsUp) {
      // Check thumbs up related achievements
      const thumbsUpCount = updatedData.achievements.thumbsUpReceived || 0;
      achievementResults = await checkAndUpdateAchievements(userId, 'THUMBS_UP_MILESTONES', thumbsUpCount);
    } else {
      // Check message related achievements
      const messagesCount = updatedData.achievements.messagesSent || 0;
      achievementResults = await checkAndUpdateAchievements(userId, 'MESSAGE_MILESTONES', messagesCount);
    }
    
    // Record events
    const eventPromises = [];
    
    // Record points earned event
    eventPromises.push(
      recordUserEvent(userId, USER_EVENT_TYPES.POINTS_EARNED, {
        amount: pointsForAction,
        reason: thumbsUp ? 'message_thumbs_up' : 'message_sent',
        multiplier
      })
    );
    
    // Record achievement events if any were unlocked
    if (achievementResults && achievementResults.newAchievements.length > 0) {
      eventPromises.push(
        recordUserEvent(userId, USER_EVENT_TYPES.ACHIEVEMENT_UNLOCKED, {
          achievements: achievementResults.newAchievements,
          bonusPoints: achievementResults.bonusPoints
        })
      );
    }
    
    // Record streak milestone event if applicable
    if (streakData && streakData.milestoneReached) {
      eventPromises.push(
        recordUserEvent(userId, USER_EVENT_TYPES.STREAK_MILESTONE, {
          streak: streakData.streak,
          bonusPoints: streakData.bonusPoints
        })
      );
    }
    
    // Wait for all event recordings to complete
    await Promise.all(eventPromises);

    console.log(
      `Points updated! Added ${pointsForAction} points (${multiplier}x multiplier).` +
      (achievementResults ? ` Unlocked ${achievementResults.newAchievements.length} achievements!` : '')
    );
    
    return {
      pointsAdded: pointsForAction,
      multiplier,
      achievements: achievementResults?.newAchievements || [],
      streakData
    };
  } catch (error) {
    console.error("Error updating points on message:", error);
  }
};


// FUTURE REWARD SYSTEM
// // Updated updatePointsOnMessage.js
// import { doc, getDoc, updateDoc, increment } from "firebase/firestore";
// import { db } from "../firebase";
// import { calculateRankProgression } from "./calculateRankProgression";
// import { calculatePointMultiplier } from "./pointMultiplier";
// import { updateUserStreak } from "./updateUserStreak";
// import { checkAndUpdateAchievements } from "./achievements";
// import { recordUserEvent, USER_EVENT_TYPES } from "./userEvents";
// import { enhanceUpdatePointsOnMessage } from './rewardHelpers';

// const originalUpdatePointsOnMessage = async (userId, thumbsUp = false) => {
//   // ALL YOUR EXISTING CODE STAYS EXACTLY THE SAME
//   const userStatsRef = doc(db, "userStats", userId);

//   try {
//     const streakData = await updateUserStreak(userId);
//     const userStatsDoc = await getDoc(userStatsRef);
//     if (!userStatsDoc.exists()) return;
    
//     const data = userStatsDoc.data();
//     const { multiplier, isNightOwl, isWeekend, isPeakHours } = calculatePointMultiplier();
//     const basePoints = thumbsUp ? 5 : 2;
//     const pointsForAction = Math.round(basePoints * multiplier);
//     const newTotalPoints = (data.points.total || 0) + pointsForAction;
//     const newDailyPoints = (data.points.daily || 0) + pointsForAction;

//     const updatePayload = {
//       "points.total": newTotalPoints,
//       "points.daily": newDailyPoints,
//     };

//     if (isNightOwl) updatePayload["multipliers.nightowl"] = increment(1);
//     if (isWeekend) updatePayload["multipliers.weekend"] = increment(1);
//     if (isPeakHours) updatePayload["multipliers.peakHours"] = increment(1);

//     if (thumbsUp) {
//       updatePayload["achievements.thumbsUpReceived"] = increment(1);
//     } else {
//       updatePayload["achievements.messagesSent"] = increment(1);
//     }

//     await updateDoc(userStatsRef, updatePayload);
//     await calculateRankProgression(userId);
    
//     const updatedUserDoc = await getDoc(userStatsRef);
//     const updatedData = updatedUserDoc.data();

//     let achievementResults = null;
    
//     if (thumbsUp) {
//       const thumbsUpCount = updatedData.achievements.thumbsUpReceived || 0;
//       achievementResults = await checkAndUpdateAchievements(userId, 'THUMBS_UP_MILESTONES', thumbsUpCount);
//     } else {
//       const messagesCount = updatedData.achievements.messagesSent || 0;
//       achievementResults = await checkAndUpdateAchievements(userId, 'MESSAGE_MILESTONES', messagesCount);
//     }
    
//     const eventPromises = [];
    
//     eventPromises.push(
//       recordUserEvent(userId, USER_EVENT_TYPES.POINTS_EARNED, {
//         amount: pointsForAction,
//         reason: thumbsUp ? 'message_thumbs_up' : 'message_sent',
//         multiplier
//       })
//     );
    
//     if (achievementResults && achievementResults.newAchievements.length > 0) {
//       eventPromises.push(
//         recordUserEvent(userId, USER_EVENT_TYPES.ACHIEVEMENT_UNLOCKED, {
//           achievements: achievementResults.newAchievements,
//           bonusPoints: achievementResults.bonusPoints
//         })
//       );
//     }
    
//     if (streakData && streakData.milestoneReached) {
//       eventPromises.push(
//         recordUserEvent(userId, USER_EVENT_TYPES.STREAK_MILESTONE, {
//           streak: streakData.streak,
//           bonusPoints: streakData.bonusPoints
//         })
//       );
//     }
    
//     await Promise.all(eventPromises);

//     console.log(
//       `Points updated! Added ${pointsForAction} points (${multiplier}x multiplier).` +
//       (achievementResults ? ` Unlocked ${achievementResults.newAchievements.length} achievements!` : '')
//     );
    
//     return {
//       pointsAdded: pointsForAction,
//       multiplier,
//       achievements: achievementResults?.newAchievements || [],
//       streakData
//     };
//   } catch (error) {
//     console.error("Error updating points on message:", error);
//   }
// };

// // NEW: Enhanced export with casino rewards
// export const updatePointsOnMessage = async (userId, thumbsUp = false) => {
//   return await enhanceUpdatePointsOnMessage(originalUpdatePointsOnMessage, userId, thumbsUp);
// };